<template>
  <v-card>
    <v-card-title>
      {{ $t('settings.clearlyaw.qrdlg.title') }}
    </v-card-title>

    <v-card-text class="pb-0 mt-8">
      <v-row justify="center">
        <v-card v-show="!loading">
          <canvas ref="qrcode"></canvas>
        </v-card>
        <v-card v-show="loading">
          <v-progress-circular indeterminate color="primary"
            :size="276" :width="1" v-show="loading">
          </v-progress-circular>
        </v-card>
      </v-row>
      <v-row justify="center" class="pt-1">
        <v-alert type="info" outlined v-show="!loading">
          {{ $t('settings.clearlyaw.qrhelp') }}
        </v-alert>
      </v-row>
    </v-card-text>

    <v-card-title class="mt-0">
      {{ $t('settings.clearlyaw.qrdlg.credInfo') }}
    </v-card-title>

    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <th class="text-right">
                {{ $t('settings.clearlyaw.qrdlg.email') }}:
              </th>
              <td>{{ email }}</td>
            </tr>
            <tr>
              <th class="text-right">
                {{ $t('settings.clearlyaw.qrdlg.passwd') }}:
              </th>
              <td>[{{ $t('settings.clearlyaw.qrdlg.pwdText') }}]</td>
            </tr>
            <tr>
              <th class="text-right">
                {{ $t('settings.clearlyaw.qrdlg.realm') }}:
              </th>
              <td>{{ realm }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-divider/>
      <v-card-actions>
      <v-btn color="primary" @click="regenerateQrCode()" text>
        <v-icon class="mr-2">mdi-restart</v-icon>
        {{ $t('settings.clearlyaw.qrdlg.reset') }}
      </v-btn>
      <v-btn color="primary" @click="emailCreds()" text>
        <v-icon class="mr-2">mdi-email-fast</v-icon>
        {{ $t('settings.clearlyaw.qrdlg.btnByEmail') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import events from 'Store/events'
import QRCode from 'qrcode'

export default {
  name: 'clearly-anywhere-creds',
  data () {
    return {
      loading: true
    }
  },
  props: {
    qrlink: {
      type: String,
      default: null
    }
  },
  watch: {
    qrlink: function (val) {
      if (val && val.length > 0) {
        this.showQRCode(val)
      } else {
        this.loading = true
      }
    }
  },
  computed: {
    ...mapGetters({
      email: 'settings/userEmail',
      realm: 'settings/realm'
    })
  },
  methods: {
    showQRCode: function (val) {
      QRCode.toCanvas(this.$refs.qrcode, val,
        { errorCorrectionLevel: 'H' }, (err) => {
          if (err) {
            this.dbg('Failed to generate canvas: %s', err)
          } else {
            this.loading = false
          }
        })
    },
    emailCreds: function () {
      API.postClearlyAnywhereCreds().then(() => {
        events.pubNotify({
          text: 'settings.clearlyaw.credsPostOK',
          status: 'success'
        })
      }).catch(err => {
        events.pubError(this.$t('settings.clearlyaw.credsPostFail') +
          API.getException(err))
      })
    },
    regenerateQrCode: function () {
      API.resetClearlyAnywhereQrCode().then(() => {
        events.pubNotify({
          text: 'settings.clearlyaw.credsResetOK',
          status: 'success'
        })
        this.$emit('reset')
      }).catch(err => {
        events.pubError(this.$t('settings.clearlyaw.credsResetFail') +
          API.getException(err))
      })
    }
  }
}
</script>

<style scoped>
</style>
